import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { all_routes } from "./router/all_routes";
import "bootstrap-daterangepicker/daterangepicker.css";
import Header from "./Header";
import Swal from "sweetalert2";
import { Select } from "antd";
import { ProductContext } from "../context/AppContext";




const ApplyEntranceExam = () => {
  const { id } = useParams();
  console.log("this is exam id", id);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const authtoken = localStorage.getItem("token");
  const { dataNew, getRegistration, Automationdata } = useContext(ProductContext);
  const [getExamExamData, setGetExamExamData] = useState(null);
  const [filteredExam, setFilteredExam] = useState([]);


  const fetchExamData = () => {
    fetch(`https://api.mirai.healthcare/api/exam-schedule?exam_id=${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        "x-auth": `${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        setGetExamExamData(response);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  };

  useEffect(() => {
    fetchExamData();
  }, []);

  const [formData, setFormData] = useState({
    exam_date: null,
  });

  const allDate =
    getExamExamData?.message?.examSchedule
      ?.map((cls) => ({
        value: new Date(cls?.exam_date).toISOString().split("T")[0],
        label: new Date(cls?.exam_date).toISOString().split("T")[0],
      }))
      .filter((value, index, self) => index === self.findIndex((t) => t.value === value.value)) || [];

  useEffect(() => {
    if (!getExamExamData || !getExamExamData.message?.examSchedule) return;

    console.log("Updated formData:", formData);

    if (formData.exam_date && formData.exam_date.value) {
      const selectedDate = formData.exam_date.value;
      console.log("Selected Date (After Change):", selectedDate);

      const selectedExams = getExamExamData.message.examSchedule.filter((exam) => {
        const examDate = new Date(exam.exam_date).toISOString().split("T")[0];

        console.log(`Exam Date: ${examDate} | Selected Date: ${selectedDate} | Match: ${examDate === selectedDate}`);

        return examDate === selectedDate;
      });

      setFilteredExam(selectedExams || []);
    } else {
      setFilteredExam(getExamExamData?.message?.examSchedule || []);
    }
  }, [formData.exam_date, getExamExamData]);





  const handleChange = (selectedOption) => {

    const formattedOption =
      typeof selectedOption === "string"
        ? { value: selectedOption, label: selectedOption }
        : selectedOption;

    console.log("Selected Option from Dropdown:", formattedOption);

    setFormData((prevState) => ({
      ...prevState,
      exam_date: formattedOption,
    }));
  };


const Regi_id = getRegistration?.data?.id;
console.log(Regi_id, "Regi_id")


 const handleSubmit = async (e, examId) => {
  if (e) {
    e.preventDefault();
  }

  if (loading) return;
  setLoading(true);

  try {
    const response = await fetch(
      "https://api.mirai.healthcare/api/exam-booking",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth": authtoken,
        },
        body: JSON.stringify({
          exam_schedule_id: examId,
          exam_id: parseInt(id),
          reg_id: Regi_id,
        }),
      }
    );

    if (response.ok) {
      await Swal.fire({
        title: "Exam Booked Successfully",
        icon: "success",
      });
      navigate("/examschedule");
    } else {
      const errorData = await response.json();
      alert(errorData.message || "Something went wrong");
    }
  } catch (error) {
    alert(error.message);
  } finally {
    setLoading(false);
  }
};



  return (
    <div className="page-wrapper">
      <Header />
      <div className="content background-color_row">
        <h3 className="page-title text-center">Exam Schedule</h3>
        <div className="row d-flex justify-content-center align-items-center background-color_row_2">
          <div className="col-md-5">
            <div className="card card_1">
              <form className="needs-validation" noValidate>
                {/* <form className="needs-validation" noValidate onSubmit={(e) => handleSubmit(e, examId)}> */}

                <label className="form-label">Date</label>
                <Select
                  className="Exam_date"
                  options={allDate}
                  value={formData.exam_date}
                  placeholder="Select Date"
                  onChange={handleChange}
                />




              </form>
            </div>
          </div>
        </div>


        <div className="row mt-4">
          {filteredExam.length > 0 ? (
            filteredExam.map((exam) => (
              <div key={exam.id} className="col-md-4 col-sm-6 mb-4">
                <div className="card h-100">
                  <div className="card-header card-buttons">
                    <h5 className="card-title">Exam Name: {exam.exam_name || "N/A"}</h5>
                  </div>
                  <div className="card-body Card_design_1">
                    <p>
                      Exam Date: <span>{new Date(exam.exam_date).toISOString().split("T")[0]}</span>
                    </p>
                    <p>Start Time: <span>{exam.start_time}</span></p>
                    <p>End Time: <span>{exam.end_time}</span></p>
                    <p>
                      Available Seats: <span>{exam.student_capacity - exam.booked_slot_count}</span>
                    </p>
                    {/* <button className="btn btn-primary mt-2" onClick={() => handleSubmit(null, exam.id)}>
                      Book Slot
                    </button> */}

                   <button
  type="button"
  className="btn btn-primary"
  disabled={loading}
  onClick={() => handleSubmit(null, exam.id)}
>
  {loading ? "Booking Exam..." : "Book Slot"}
</button>


                  </div>
                </div>
              </div>
            ))
          ) : (
            
            <div
              className="card"
              style={{
                padding: "40px 20px",
                width: "80%",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              <p style={{ fontSize: "22px", color: "#060606" }}>
                Time limit may have exceeded for slot booking. Please contact
                the school administration.
                <br />
                <b>{Automationdata?.data?.[0]?.contact_number}</b>,{" "}
                <b>{Automationdata?.data?.[0]?.email}</b>
              </p>
            </div>

          )}
        </div>
      </div>
    </div>
  );
};




export default ApplyEntranceExam;